import { mapState, mapGetters, mapActions } from 'vuex'
 
export const modalsComputed = {
  ...mapState('modals', { 

    isResetPassModalOpen: (state) => state.isResetPassModalOpen,
    emailToReset: (state) => state.emailToReset,

    isConfirmationModalOpen: (state) => state.isConfirmationModalOpen,
    interested: (state) => state.interested, 
    userUuid: (state) => state.userUuid,
    vacancyId: (state) => state.vacancyId,
 
  }),
  ...mapGetters('modals', ['isResetPassModalOpen', 'emailToReset', 'isConfirmationModalOpen', 'interested', 'userUuid', 'vacancyId']),
}

export const modalsMethods = mapActions('modals', ['toggleResetPassModal', 'setEmailToResetVal', 'toggleConfirmationModal','toggleInterested', 'resetInterested', 'setUserUuidValue', 'setVacancyIdValue'])



export const authComputed = {
    ...mapState('auth', { 
      token: (state) => state.token,
      tokenType: (state) => state.tokenType,
      expiration: (state) => state.expiration,
      email: (state) => state.email,
      password: (state) => state.password,

      loggedUser: (state) => state.loggedUser, 
    }),
    ...mapGetters('auth', ['isTokenExpired', 'loggedUser', 'token']),
}

export const authMethods = mapActions('auth', ['login', 'register', 'updateCandidate', 'refreshToken', 'logout'])


export const dashboardComputed = {
  ...mapState('dashboard', {  
    jdsData: (state) => state.jdsData,
    jdsCount: (state) => state.jdsCount,

    ngtgData: (state) => state.ngtgData,
    ngtgCount: (state) => state.ngtgCount,

    gtgData: (state) => state.gtgData,
    gtgCount: (state) => state.gtgCount,

    cvsData: (state) => state.cvsData,
    cvsCount: (state) => state.cvsCount, 

    pipelineData: (state) => state.pipelineData,
    pipelineCount: (state) => state.pipelineCount,

    canceledData: (state) => state.canceledData,
    canceledCount: (state) => state.canceledCount, 
  }),
  ...mapGetters('dashboard', ['jdsData', 'jdsCount', 'ngtgData', 'ngtgCount', 'gtgData', 'gtgCount', 'cvsData', 'cvsCount', 'pipelineData', 'pipelineCount', 'canceledData' ,'canceledCount']),
}

export const dashboardMethods = mapActions('dashboard', ['fetchDashboardData'])